// File configures the Showdown library which is used for parsing markdown text.

const Showdown = require('showdown');
require('showdown-youtube');
const Converter = new Showdown.Converter({
  extensions: ['youtube']
});

/**
 * Showdown Markdown converter.
 * @type {Converter}
 */
export default Converter;



// WEBPACK FOOTER //
// ./src/class/Showdown.js